export class OldSystemSurveyDTO{
  public TimeIssue : boolean;
  public GraphicIssue : boolean;
  public FunctionalIssue : boolean;
  public OtherIssue : string;
  public Name : string;
  public Email : string;
}
